import { type MutationError, trpc } from '@/shared/api';

interface UseRemoveExhibitionProductOptions {
  readonly onSuccess?: () => void;
}

/** 기획전에서 상품 연결을 푼다. 이미 없으면 서버가 그대로 성공시킨다(멱등). */
export const useRemoveExhibitionProduct = ({
  onSuccess,
}: UseRemoveExhibitionProductOptions = {}) => {
  const mutation = trpc.productManagement.exhibitions.removeProduct.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    removeProduct: (exhibitionId: string, productId: string) =>
      mutation.mutate({ exhibitionId, productId }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 모달의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
